import { Injectable, Signal, signal, WritableSignal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private readonly _short: WritableSignal<boolean> = signal(false)

  public get short(): Signal<boolean> {
    return this._short;
  }

  public set short(value: boolean) {
    this._short.set(value);
  }

}
